import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { queryKeys } from '@/lib/queryClient';
import { shieldApi, type ShieldTransactionsQuery, type WithdrawPayload } from '../api/shield.api';

export function useShieldBalance() {
  return useQuery({
    queryKey: queryKeys.shield.balance(),
    queryFn: () => shieldApi.getBalance(),
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
  });
}

export function useShieldTransactions(query: ShieldTransactionsQuery = {}) {
  return useQuery({
    queryKey: queryKeys.shield.transactions(query as Record<string, unknown>),
    queryFn: () => shieldApi.getTransactions(query),
    staleTime: 30 * 1000,
  });
}

export function useShieldWithdraw() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: WithdrawPayload) => shieldApi.withdraw(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.shield.all });
      toast.success('Withdrawal processed successfully');
    },
  });
}